import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { userSetAttributesAction } from 'js/hooks/user/store/actions';
import { useAppSelector } from 'js/store/hooks';

import * as server from 'js/hooks/auth/server';
import { useLoginRequest } from 'js/hooks/auth/hooks/useLoginRequest';

export const useLoginBySessionToken = () => {
    const request = useLoginRequest();
    const dispatch = useDispatch();
    const clientType = useAppSelector(prop('clientType'));

    return useCallback(async (userName, pasSessionToken) => {
        const response = await server.login({ ...request, userName, sessionToken: pasSessionToken, clientType });
        const playerSessionInfoResponse = await server.getPlayerSessionInfo();

        const playerSessionInfo = playerSessionInfoResponse?.data?.parameters || [];
        const rootSessionStartTime = playerSessionInfo?.find(param => param.key === 'rootSessionStartTime')?.value || '';
        const { sessionToken, previousLoginTime, sessionTokenExpirationTime } = response?.data || {};
        const sessionStartTime = Number(new Date(`${rootSessionStartTime.trim().replace(' ', 'T')}Z`)) || Date.now();

        dispatch(userSetAttributesAction({
            sessionToken,
            pasSessionToken,
            sessionStartTime,
            previousLoginTime,
            sessionTokenExpirationTime
        }));

        return response;
    }, [request, clientType, dispatch]);
};
